module.exports = __webpack_public_path__ + "static/media/assignment_ind.d808e9d3.svg";